module.exports = __webpack_public_path__ + "img/image136.23442605.jpg";